import requestv2 from "~/utils/http-v2";

const pendingReceiptApi = {
	gets: async (params) => {
		const url = 'v2/pending-receipt';
		return await requestv2.get(url, {params});
	},
	add: async (params) => {
		const url = 'v2/pending-receipt';
		return await requestv2.post(url, params);
	},
	update: async (params) => {
		const url = `v2/pending-receipt/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete: async (id) => {
		const url = `v2/pending-receipt/${id}`;
		return await requestv2.delete(url);
	},
	status: async (params) => {
		const url = `v2/pending-receipt/status/${params.id}`;
		return await requestv2.post(url, params);
	},
};

export default pendingReceiptApi;
